import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	container: {
		position: 'relative',
		paddingTop: theme.spacing.small,

		[getFromBreakpoint('md')]: {
			paddingTop: theme.spacing.large,
		},
	},
	matrixContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.small,
		justifyContent: 'center',
		alignItems: 'center',
	},
	alert: {
		marginTop: theme.spacing.xsmall,
	},
	noOffersLink: {
		color: 'inherit',
		fontWeight: theme.weight.bold,
		textDecoration: 'underline',
	},
	swiftDepartureDates: {
		position: 'relative',
		bottom: 0,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		width: '100%',
	},
	hiddenButton: {
		visibility: 'hidden',
	},
	itemOffersContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: theme.spacing.xxsmall,
	},
	matrixColumn: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.xxsmall,
	},
	matrixItem: {
		display: 'flex',
		boxSizing: 'border-box',
		flexDirection: 'column',
		justifyContent: 'space-between',
		padding: `${theme.spacing.xxsmall} ${theme.spacing.xsmall}`,
		border: theme.singleSelect.list.border,
		borderRadius: theme.borderRadius.rounded,
		width: '100px',
		height: '70px',
		cursor: 'pointer',
		background: theme.palette.neutral[5],
		textAlign: 'center',

		':hover': {
			backgroundColor: theme.palette.neutral[10],
		},
	},
	emptyMatrixItem: {
		cursor: 'not-allowed',
		background: theme.palette.neutral[0],

		':hover': {
			backgroundColor: theme.palette.neutral[0],
		},
	},
	selected: {
		color: theme.palette.neutral[0],
		backgroundColor: theme.primary.color.default,
		borderColor: theme.primary.color.default,

		':hover': {
			backgroundColor: theme.primary.color.hover,
			borderColor: theme.primary.color.hover,
		},
	},
	cheapest: {
		backgroundColor: theme.palette.semantic.green[20],
		borderColor: theme.palette.semantic.green[20],
		color: theme.palette.neutral[100],

		':hover': {
			backgroundColor: theme.palette.semantic.green[40],
			borderColor: theme.palette.semantic.green[40],
		},
	},
	iconContainer: {
		display: 'flex',
		justifyContent: 'center',
		gap: theme.spacing.xxsmall,
	},
	iconIncludingContainer: {
		display: 'flex',
		gap: theme.spacing.xxsmall,
	},
	matrixDate: {
		textAlign: 'center',
	},
	matrixDuration: {
		textAlign: 'center',
		display: 'flex',
		alignItems: 'center',
		height: '70px',
	},
	matrixDurationColumn: {
		display: 'flex',
		gap: theme.spacing.xxsmall,
		flexDirection: 'column',
		justifyContent: 'flex-end',
	},
	dealIcon: {
		color: theme.flashDeal.background.color,
	},
}));
